import React from 'react'
import Header2 from '../components/Layouts/Header2'
const UserPage = () => {
  return (
    <>
    <main>
        <Header2/>
    </main>
    </>
  )
}

export default UserPage
